import { FormProvider } from 'react-hook-form';
import { useLegacyCreateClientForm } from './hooks';
import { convertToPresentationProps } from './logics';
import { LegacyCreateClientFormPresentation } from './presentations';

/**
 * 利用企業作成フォームのコンテナコンポーネント（Legacy版）
 * NOTE: Suspenseを使用するhookを含むため、親コンポーネントでSuspenseでラップしてください
 */
export const LegacyCreateClientForm: React.FC = () => {
  const {
    state: { methods, isButtonDisabled, groups, clientFeatureFlags, partnerFeatureFlags },
    actions: { handleOnSubmit },
  } = useLegacyCreateClientForm();

  const { groupOptions, featureFlags: featureFlagOptions } = convertToPresentationProps({
    groups,
    clientFeatureFlags,
    partnerFeatureFlags,
  });

  return (
    <FormProvider {...methods}>
      <LegacyCreateClientFormPresentation
        isButtonDisabled={isButtonDisabled}
        groupOptions={groupOptions}
        onSubmit={handleOnSubmit}
        featureFlags={featureFlagOptions}
      />
    </FormProvider>
  );
};
